// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pr-page {
  --bg: #F1EFE8;
  --surface: #FFFFFF;
  --surface-2: #FAF9F5;
  --ink: #2C2C2A;
  --ink-2: #57544D;
  --ink-3: #888780;
  --line: #E5E2D9;
  --line-2: #C9C5B8;
  --info-bg: #E6F1FB;
  --info: #185FA5;
  --info-line: #B8D5EE;
  --ok-bg: #EAF3DE;
  --ok: #3B6D11;
  --ok-line: #97C459;
  --warn-bg: #FAEEDA;
  --warn: #854F0B;
  --warn-line: #EF9F27;
  --bad-bg: #FBEAF0;
  --bad: #993556;
  --bad-line: #ED93B1;
  --purple-bg: #EEEDFE;
  --purple: #3C3489;
  --purple-line: #AFA9EC;
  --r: 10px;
  --r-sm: 7px;
  --r-lg: 14px;
  --font: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  --mono: "SF Mono", Monaco, Consolas, monospace;

  min-height: 100vh;
  font-family: var(--font);
  font-size: 13px;
  line-height: 1.45;
  color: var(--ink);
  background: var(--bg);
  -webkit-font-smoothing: antialiased;
  padding-top: 50px;
}

.pr-page .tnum { font-variant-numeric: tabular-nums; }
.pr-page .truncate { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

.pr-page-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 12px 18px 0;
}

.pr-page-btn {
  padding: 7px 12px;
  border: 1px solid var(--line);
  background: var(--surface);
  border-radius: var(--r-sm);
  font-size: 12px;
  color: var(--ink-2);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-family: inherit;
  text-decoration: none;
}

.pr-page-btn:hover { border-color: var(--line-2); }

.pr-kpis {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
  padding: 14px 18px 0;
}

.pr-kpi {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r);
  padding: 10px 12px;
}

.pr-kpi-label {
  font-size: 10px;
  color: var(--ink-3);
  margin-bottom: 3px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.pr-kpi-value { font-size: 17px; font-weight: 500; line-height: 1.1; }
.pr-kpi-value.warn { color: var(--warn); }
.pr-kpi-value.bad { color: var(--bad); }
.pr-kpi-value.ok { color: var(--ok); }
.pr-kpi-foot { font-size: 9px; color: var(--ink-3); margin-top: 2px; }

.pr-wrap {
  display: grid;
  grid-template-columns: 1.55fr 1fr;
  gap: 14px;
  padding: 14px 18px 40px;
  align-items: start;
}

@media (max-width: 1080px) {
  .pr-wrap { grid-template-columns: 1fr; }
  .pr-kpis { grid-template-columns: repeat(3, 1fr); }
}

.pr-col { display: flex; flex-direction: column; gap: 14px; }

.pr-panel {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  overflow: hidden;
}

.pr-panel-head {
  padding: 13px 15px;
  border-bottom: 1px solid var(--line);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.pr-panel-title {
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 7px;
}

.pr-panel-title .pr-step {
  width: 19px;
  height: 19px;
  border-radius: 50%;
  background: var(--ink);
  color: #fff;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pr-panel-sub { font-size: 11px; color: var(--ink-3); margin-top: 1px; }
.pr-panel-body { padding: 14px 15px; }

.pr-seg {
  display: inline-flex;
  background: var(--bg);
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  padding: 2px;
}

.pr-seg button {
  border: none;
  background: transparent;
  padding: 6px 12px;
  font-size: 12px;
  font-family: inherit;
  color: var(--ink-2);
  border-radius: 5px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.pr-seg button.active {
  background: var(--surface);
  color: var(--ink);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  font-weight: 500;
}

.pr-filters {
  display: flex;
  gap: 7px;
  margin-bottom: 12px;
  flex-wrap: wrap;
  align-items: center;
}

.pr-search { position: relative; flex: 1 1; min-width: 160px; }
.pr-search i { position: absolute; left: 9px; top: 50%; transform: translateY(-50%); color: var(--ink-3); font-size: 14px; }
.pr-search input {
  width: 100%;
  padding: 8px 10px 8px 28px;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  font-size: 12px;
  font-family: inherit;
  outline: none;
  background: var(--surface-2);
}

.pr-search input:focus { border-color: var(--info-line); background: var(--surface); }

.pr-selectbox {
  padding: 8px 10px;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  font-size: 12px;
  font-family: inherit;
  background: var(--surface-2);
  color: var(--ink-2);
  outline: none;
  cursor: pointer;
}

.pr-chip-toggle {
  padding: 7px 11px;
  border: 1px solid var(--line);
  border-radius: 16px;
  font-size: 11px;
  color: var(--ink-2);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  -webkit-user-select: none;
          user-select: none;
}

.pr-chip-toggle.on {
  background: var(--warn-bg);
  border-color: var(--warn-line);
  color: var(--warn);
  font-weight: 500;
}

.pr-bills { border: 1px solid var(--line); border-radius: var(--r); overflow: hidden; }

.pr-bills-head,
.pr-bill-row {
  display: grid;
  grid-template-columns: 30px 1.4fr 0.9fr 0.8fr 0.7fr;
  gap: 8px;
  align-items: center;
  padding: 8px 11px;
}

.pr-bills-head {
  background: var(--surface-2);
  font-size: 9px;
  letter-spacing: 0.4px;
  color: var(--ink-3);
  font-weight: 500;
  text-transform: uppercase;
  border-bottom: 1px solid var(--line);
}

.pr-bill-row { border-bottom: 1px solid var(--line); cursor: pointer; }
.pr-bill-row:last-child { border-bottom: none; }
.pr-bill-row:hover { background: var(--surface-2); }
.pr-bill-row.sel { background: var(--info-bg); }

.pr-bill-cust { font-size: 12px; font-weight: 500; }
.pr-bill-meta { font-size: 10px; color: var(--ink-3); }
.pr-bill-amt { font-size: 12px; font-weight: 500; text-align: right; }
.pr-bill-due { font-size: 11px; }

.pr-age {
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 7px;
  display: inline-block;
  font-weight: 500;
}

.pr-age.cur { background: var(--ok-bg); color: var(--ok); }
.pr-age.w30 { background: var(--warn-bg); color: var(--warn); }
.pr-age.w60 { background: #F6E0C8; color: #7A3E05; }
.pr-age.w90 { background: var(--bad-bg); color: var(--bad); }

.pr-ck {
  width: 17px;
  height: 17px;
  border: 1.5px solid var(--line-2);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: transparent;
}

.pr-bill-row.sel .pr-ck,
.pr-ck.on {
  background: var(--info);
  border-color: var(--info);
  color: #fff;
}

.pr-ck i { font-size: 12px; }

.pr-bills-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 9px 11px;
  background: var(--surface-2);
  border-top: 1px solid var(--line);
  font-size: 11px;
  color: var(--ink-2);
}

.pr-pagination {
  margin-top: 12px;
  padding: 4px 2px 0;
  display: flex;
  justify-content: flex-end;
}

.pr-pagination .pagination-container {
  width: auto;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.pr-pagination .help-text {
  display: none;
}

.pr-pagination .pagination-button {
  font-size: 11px;
  padding: 6px 12px;
  border-radius: 7px;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--ink-2);
}

.pr-pagination .pagination-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.pr-pagination .pagination-button:not(:disabled):hover {
  background: var(--surface-2);
  border-color: var(--line-2);
}

.pr-link { color: var(--info); cursor: pointer; font-weight: 500; background: none; border: none; font-family: inherit; font-size: inherit; padding: 0; }

.pr-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }

.pr-fld { display: flex; flex-direction: column; gap: 4px; }
.pr-fld label { font-size: 11px; color: var(--ink-2); }

.pr-fld input {
  padding: 8px 10px;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  font-size: 12px;
  font-family: inherit;
  outline: none;
  background: var(--surface-2);
  color: var(--ink);
}

.pr-fld input:focus { border-color: var(--info-line); background: var(--surface); }

.pr-basket-item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 8px 10px;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  margin-bottom: 6px;
  background: var(--surface-2);
}

.pr-basket-meta { flex: 1 1; min-width: 0; }
.pr-basket-name { font-size: 12px; font-weight: 500; }
.pr-basket-sub { font-size: 10px; color: var(--ink-3); }
.pr-basket-amt { font-size: 12px; font-weight: 500; }
.pr-x-btn { color: var(--ink-3); cursor: pointer; font-size: 15px; background: none; border: none; padding: 0; }
.pr-x-btn:hover { color: var(--bad); }

.pr-pod-add {
  width: 34px;
  height: 34px;
  border: 1.5px dashed var(--line-2);
  border-radius: var(--r-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ink-3);
  cursor: pointer;
  flex-shrink: 0;
}

.pr-pod-add:hover { border-color: var(--info); color: var(--info); }
.pr-pod-add i { font-size: 16px; }

.pr-pod-thumb {
  width: 34px;
  height: 34px;
  border-radius: var(--r-sm);
  overflow: hidden;
  position: relative;
  cursor: pointer;
  flex-shrink: 0;
  border: 1px solid var(--ok-line);
}

.pr-pod-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }

.pr-pod-tick {
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 14px;
  height: 14px;
  background: var(--ok);
  color: #fff;
  border-radius: 4px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pr-pod-tick i { font-size: 9px; }

.pr-cfg-label {
  font-size: 10px;
  letter-spacing: 0.4px;
  color: var(--ink-3);
  font-weight: 500;
  text-transform: uppercase;
  margin: 0 0 9px;
}

.pr-cfg-block { padding: 14px 15px; border-bottom: 1px solid var(--line); }
.pr-cfg-block:last-child { border-bottom: none; }

.pr-channels { display: flex; gap: 8px; }

.pr-channel {
  flex: 1 1;
  border: 1px solid var(--line);
  border-radius: var(--r);
  padding: 11px 8px;
  text-align: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.pr-channel i { font-size: 19px; color: var(--ink-3); }
.pr-channel-name { font-size: 11px; margin-top: 4px; color: var(--ink-2); }
.pr-channel.on { border-color: var(--info-line); background: var(--info-bg); }
.pr-channel.on i { color: var(--info); }
.pr-channel.on .pr-channel-name { color: var(--info); font-weight: 500; }
.pr-channel .pr-tick { font-size: 11px; color: var(--info); height: 13px; }

.pr-rule { display: flex; align-items: center; gap: 9px; padding: 7px 0; cursor: pointer; }

.pr-rule .pr-box {
  width: 17px;
  height: 17px;
  border: 1.5px solid var(--line-2);
  border-radius: 4px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: transparent;
}

.pr-rule.on .pr-box { background: var(--info); border-color: var(--info); color: #fff; }
.pr-rule .pr-box i { font-size: 12px; }
.pr-rule-txt { font-size: 12px; }
.pr-rule-sub { font-size: 10px; color: var(--ink-3); }

.pr-rule.recommend .pr-rule-txt::after {
  content: "AI pick";
  font-size: 8px;
  background: var(--purple-bg);
  color: var(--purple);
  padding: 1px 5px;
  border-radius: 6px;
  margin-left: 6px;
  vertical-align: middle;
  font-weight: 500;
}

.pr-var-row { display: flex; flex-wrap: wrap; gap: 5px; margin: 8px 0; }

.pr-var {
  font-size: 10px;
  background: var(--bg);
  border: 1px solid var(--line);
  padding: 3px 7px;
  border-radius: 6px;
  cursor: pointer;
  color: var(--ink-2);
  font-family: var(--mono);
}

.pr-var:hover { border-color: var(--info-line); color: var(--info); }

.pr-preview {
  background: var(--surface-2);
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  padding: 11px;
  font-size: 12px;
  color: var(--ink-2);
  line-height: 1.6;
  white-space: pre-wrap;
}

.pr-preview .pr-v {
  background: var(--info-bg);
  color: var(--info);
  border-radius: 3px;
  padding: 0 3px;
}

.pr-preview.pr-purple {
  border-color: var(--purple-line);
  background: var(--purple-bg);
}

.pr-preview .pr-v-purple {
  background: #DAD7F7;
  color: var(--purple);
  border-radius: 3px;
  padding: 0 3px;
}

.pr-switch-row { display: flex; align-items: center; justify-content: space-between; padding: 7px 0; }
.pr-switch-row .pr-lbl { font-size: 12px; }
.pr-switch-row .pr-sub { font-size: 10px; color: var(--ink-3); }

.pr-sw {
  width: 36px;
  height: 21px;
  border-radius: 11px;
  background: var(--line-2);
  position: relative;
  cursor: pointer;
  transition: background 0.15s;
  flex-shrink: 0;
}

.pr-sw::after {
  content: "";
  position: absolute;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background: #fff;
  top: 2px;
  left: 2px;
  transition: left 0.15s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.pr-sw.on { background: var(--ok); }
.pr-sw.on::after { left: 17px; }
.pr-sw.locked { opacity: 0.55; cursor: not-allowed; }

.pr-soon-badge {
    display: inline-block;
    margin-left: 6px;
    padding: 1px 6px;
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: var(--info);
    background: var(--info-bg);
    border: 1px solid var(--info-line);
    border-radius: 4px;
    vertical-align: middle;
}

.pr-due-input {
    font-size: 11px;
    padding: 3px 6px;
    border: 1px solid var(--line);
    border-radius: 5px;
    background: var(--surface);
    color: var(--ink);
    max-width: 130px;
}

.pr-due-input.inline {
    margin: 0 4px;
    vertical-align: middle;
}

.pr-esc-step {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 6px 0;
  font-size: 11px;
  color: var(--ink-2);
}

.pr-esc-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }

.pr-attach-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; }

.pr-attach {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: var(--ink-2);
  padding: 7px 9px;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  cursor: pointer;
  background: none;
  font-family: inherit;
}

.pr-attach.on { border-color: var(--ok-line); background: var(--ok-bg); color: var(--ok); }
.pr-attach i { font-size: 14px; }

.pr-tmpl-textarea {
  width: 100%;
  min-height: 96px;
  padding: 10px;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  font-family: inherit;
  font-size: 12px;
  resize: vertical;
  outline: none;
  background: var(--surface-2);
  box-sizing: border-box;
}

.pr-tmpl-textarea:focus { border-color: var(--info-line); background: var(--surface); }

.pr-launch { position: sticky; bottom: 0; }

.pr-summary-row {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  padding: 4px 0;
  color: var(--ink-2);
}

.pr-summary-row b { color: var(--ink); font-weight: 500; }

.pr-btn {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: var(--r);
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.pr-btn.primary { background: var(--ink); color: #fff; }
.pr-btn.primary:hover:not(:disabled) { opacity: 0.92; }
.pr-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.pr-btn.ghost {
  background: transparent;
  border: 1px solid var(--line);
  color: var(--ink-2);
  width: auto;
  padding: 10px 16px;
}

.pr-empty { text-align: center; padding: 26px 14px; color: var(--ink-3); }
.pr-empty i { font-size: 30px; color: var(--line-2); display: block; margin-bottom: 8px; }

.pr-toast-wrap {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 80;
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
}

.pr-toast {
  background: var(--ink);
  color: #fff;
  padding: 10px 16px;
  border-radius: var(--r-sm);
  font-size: 12px;
  display: flex;
  gap: 8px;
  align-items: center;
  animation: pr-rise 0.2s;
}

.pr-toast.bad { background: var(--bad); }

@keyframes pr-rise {
  from { transform: translateY(8px); opacity: 0; }
}

.pr-modal-bg {
  position: fixed;
  inset: 0;
  background: rgba(26, 26, 26, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 90;
  padding: 20px;
}

.pr-modal {
  background: var(--surface);
  border-radius: var(--r-lg);
  max-width: 440px;
  width: 100%;
  overflow: hidden;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.3);
}

.pr-modal-top { padding: 18px 20px; text-align: center; }

.pr-modal-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: var(--ok-bg);
  color: var(--ok);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  font-size: 26px;
}

.pr-modal-title { font-size: 16px; font-weight: 500; margin-bottom: 5px; }
.pr-modal-msg { font-size: 12px; color: var(--ink-2); line-height: 1.55; }

.pr-modal-list {
  background: var(--surface-2);
  border-radius: var(--r-sm);
  padding: 11px 13px;
  margin: 13px 0 0;
  text-align: left;
}

.pr-modal-foot { padding: 0 20px 18px; display: flex; gap: 8px; }

.pr-pay-list {
  margin-top: 14px;
  max-height: 280px;
  overflow: auto;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  background: var(--surface-2);
}

.pr-pay-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--line);
}

.pr-pay-row:last-child { border-bottom: none; }

.pr-pay-main { min-width: 0; flex: 1 1; }

.pr-pay-customer {
  font-weight: 500;
  font-size: 12px;
}

.pr-pay-meta {
  font-size: 11px;
  color: var(--ink-3);
  margin-top: 2px;
}

.pr-pay-id {
  font-family: var(--mono);
  font-size: 10px;
  color: var(--ok);
  background: var(--ok-bg);
  border: 1px solid var(--ok-line);
  border-radius: 6px;
  padding: 4px 7px;
  white-space: nowrap;
  max-width: 46%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pr-pod-hint {
  font-size: 10px;
  color: var(--ink-3);
  margin-top: 6px;
  display: flex;
  gap: 5px;
  align-items: flex-start;
}

.pr-pod-hint i { font-size: 12px; margin-top: 1px; }
`, "",{"version":3,"sources":["webpack://./src/Css/PaymentReminders.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kGAAkG;EAClG,8CAA8C;;EAE9C,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA,iBAAiB,kCAAkC,EAAE;AACrD,qBAAqB,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;;AAErF;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,qBAAqB,2BAA2B,EAAE;;AAElD;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACrE,qBAAqB,kBAAkB,EAAE;AACzC,oBAAoB,iBAAiB,EAAE;AACvC,mBAAmB,gBAAgB,EAAE;AACrC,eAAe,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAErE;EACE,aAAa;EACb,iCAAiC;EACjC,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,WAAW,qCAAqC,EAAE;AACpD;;AAEA,UAAU,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE5D;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,gBAAgB,eAAe,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACvE,iBAAiB,kBAAkB,EAAE;;AAErC;EACE,oBAAoB;EACpB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA,aAAa,kBAAkB,EAAE,SAAO,EAAE,gBAAgB,EAAE;AAC5D,eAAe,kBAAkB,EAAE,SAAS,EAAE,QAAQ,EAAE,2BAA2B,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC3H;EACE,WAAW;EACX,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,4BAA4B;AAC9B;;AAEA,yBAAyB,8BAA8B,EAAE,0BAA0B,EAAE;;AAErF;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY,6BAA6B,EAAE,uBAAuB,EAAE,gBAAgB,EAAE;;AAEtF;;EAEE,aAAa;EACb,mDAAmD;EACnD,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,eAAe,oCAAoC,EAAE,eAAe,EAAE;AACtE,0BAA0B,mBAAmB,EAAE;AAC/C,qBAAqB,4BAA4B,EAAE;AACnD,mBAAmB,0BAA0B,EAAE;;AAE/C,gBAAgB,eAAe,EAAE,gBAAgB,EAAE;AACnD,gBAAgB,eAAe,EAAE,mBAAmB,EAAE;AACtD,eAAe,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACrE,eAAe,eAAe,EAAE;;AAEhC;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,cAAc,wBAAwB,EAAE,gBAAgB,EAAE;AAC1D,cAAc,0BAA0B,EAAE,kBAAkB,EAAE;AAC9D,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,cAAc,yBAAyB,EAAE,iBAAiB,EAAE;;AAE5D;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;AACb;;AAEA,WAAW,eAAe,EAAE;;AAE5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,iCAAiC;EACjC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,WAAW,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,YAAY,EAAE,oBAAoB,EAAE,kBAAkB,EAAE,UAAU,EAAE;;AAExJ,gBAAgB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;;AAE1E,UAAU,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC3D,gBAAgB,eAAe,EAAE,mBAAmB,EAAE;;AAEtD;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,sBAAsB,8BAA8B,EAAE,0BAA0B,EAAE;;AAElF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,kBAAkB,SAAO,EAAE,YAAY,EAAE;AACzC,kBAAkB,eAAe,EAAE,gBAAgB,EAAE;AACrD,iBAAiB,eAAe,EAAE,mBAAmB,EAAE;AACvD,iBAAiB,eAAe,EAAE,gBAAgB,EAAE;AACpD,YAAY,mBAAmB,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,YAAY,EAAE,UAAU,EAAE;AAC/G,kBAAkB,iBAAiB,EAAE;;AAErC;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB,yBAAyB,EAAE,kBAAkB,EAAE;AACnE,gBAAgB,eAAe,EAAE;;AAEjC;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA,oBAAoB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,cAAc,EAAE;;AAElF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,iBAAiB,cAAc,EAAE;;AAEjC;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,gBAAgB,kBAAkB,EAAE,oCAAoC,EAAE;AAC1E,2BAA2B,mBAAmB,EAAE;;AAEhD,eAAe,aAAa,EAAE,QAAQ,EAAE;;AAExC;EACE,SAAO;EACP,6BAA6B;EAC7B,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,gBAAgB,eAAe,EAAE,mBAAmB,EAAE;AACtD,mBAAmB,eAAe,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAC1E,iBAAiB,8BAA8B,EAAE,0BAA0B,EAAE;AAC7E,mBAAmB,kBAAkB,EAAE;AACvC,kCAAkC,kBAAkB,EAAE,gBAAgB,EAAE;AACxE,uBAAuB,eAAe,EAAE,kBAAkB,EAAE,YAAY,EAAE;;AAE1E,WAAW,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE,eAAe,EAAE;;AAE1F;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,sBAAsB,uBAAuB,EAAE,yBAAyB,EAAE,WAAW,EAAE;AACvF,qBAAqB,eAAe,EAAE;AACtC,eAAe,eAAe,EAAE;AAChC,eAAe,eAAe,EAAE,mBAAmB,EAAE;;AAErD;EACE,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,cAAc,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,aAAa,EAAE;;AAEvE;EACE,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,gBAAgB,8BAA8B,EAAE,kBAAkB,EAAE;;AAEpE;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,cAAc,EAAE;AACrG,yBAAyB,eAAe,EAAE;AAC1C,yBAAyB,eAAe,EAAE,mBAAmB,EAAE;;AAE/D;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,YAAY,qBAAqB,EAAE;AACnC,mBAAmB,UAAU,EAAE;AAC/B,gBAAgB,aAAa,EAAE,mBAAmB,EAAE;;AAEpD;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;IAC1B,kCAAkC;IAClC,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,cAAc,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE;;AAE3E,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,QAAQ,EAAE;;AAE3E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,gBAAgB,4BAA4B,EAAE,wBAAwB,EAAE,gBAAgB,EAAE;AAC1F,eAAe,eAAe,EAAE;;AAEhC;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA,0BAA0B,8BAA8B,EAAE,0BAA0B,EAAE;;AAEtF,aAAa,gBAAgB,EAAE,SAAS,EAAE;;AAE1C;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE;;AAEzD;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,kBAAkB,sBAAsB,EAAE,WAAW,EAAE;AACvD,uCAAuC,aAAa,EAAE;AACtD,mBAAmB,YAAY,EAAE,mBAAmB,EAAE;AACtD;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA,YAAY,kBAAkB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AACzE,cAAc,eAAe,EAAE,oBAAoB,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAEzF;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,gBAAgB,sBAAsB,EAAE;;AAExC;EACE,OAAO,0BAA0B,EAAE,UAAU,EAAE;AACjD;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,gBAAgB,kBAAkB,EAAE,kBAAkB,EAAE;;AAExD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACzE,gBAAgB,eAAe,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;;AAEzE;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iBAAiB,oBAAoB,EAAE,aAAa,EAAE,QAAQ,EAAE;;AAEhE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,yBAAyB,mBAAmB,EAAE;;AAE9C,eAAe,YAAY,EAAE,SAAO,EAAE;;AAEtC;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA,iBAAiB,eAAe,EAAE,eAAe,EAAE","sourcesContent":[".pr-page {\r\n  --bg: #F1EFE8;\r\n  --surface: #FFFFFF;\r\n  --surface-2: #FAF9F5;\r\n  --ink: #2C2C2A;\r\n  --ink-2: #57544D;\r\n  --ink-3: #888780;\r\n  --line: #E5E2D9;\r\n  --line-2: #C9C5B8;\r\n  --info-bg: #E6F1FB;\r\n  --info: #185FA5;\r\n  --info-line: #B8D5EE;\r\n  --ok-bg: #EAF3DE;\r\n  --ok: #3B6D11;\r\n  --ok-line: #97C459;\r\n  --warn-bg: #FAEEDA;\r\n  --warn: #854F0B;\r\n  --warn-line: #EF9F27;\r\n  --bad-bg: #FBEAF0;\r\n  --bad: #993556;\r\n  --bad-line: #ED93B1;\r\n  --purple-bg: #EEEDFE;\r\n  --purple: #3C3489;\r\n  --purple-line: #AFA9EC;\r\n  --r: 10px;\r\n  --r-sm: 7px;\r\n  --r-lg: 14px;\r\n  --font: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\r\n  --mono: \"SF Mono\", Monaco, Consolas, monospace;\r\n\r\n  min-height: 100vh;\r\n  font-family: var(--font);\r\n  font-size: 13px;\r\n  line-height: 1.45;\r\n  color: var(--ink);\r\n  background: var(--bg);\r\n  -webkit-font-smoothing: antialiased;\r\n  padding-top: 50px;\r\n}\r\n\r\n.pr-page .tnum { font-variant-numeric: tabular-nums; }\r\n.pr-page .truncate { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\r\n\r\n.pr-page-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 12px 18px 0;\r\n}\r\n\r\n.pr-page-btn {\r\n  padding: 7px 12px;\r\n  border: 1px solid var(--line);\r\n  background: var(--surface);\r\n  border-radius: var(--r-sm);\r\n  font-size: 12px;\r\n  color: var(--ink-2);\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-family: inherit;\r\n  text-decoration: none;\r\n}\r\n\r\n.pr-page-btn:hover { border-color: var(--line-2); }\r\n\r\n.pr-kpis {\r\n  display: grid;\r\n  grid-template-columns: repeat(6, 1fr);\r\n  gap: 8px;\r\n  padding: 14px 18px 0;\r\n}\r\n\r\n.pr-kpi {\r\n  background: var(--surface);\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r);\r\n  padding: 10px 12px;\r\n}\r\n\r\n.pr-kpi-label {\r\n  font-size: 10px;\r\n  color: var(--ink-3);\r\n  margin-bottom: 3px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.pr-kpi-value { font-size: 17px; font-weight: 500; line-height: 1.1; }\r\n.pr-kpi-value.warn { color: var(--warn); }\r\n.pr-kpi-value.bad { color: var(--bad); }\r\n.pr-kpi-value.ok { color: var(--ok); }\r\n.pr-kpi-foot { font-size: 9px; color: var(--ink-3); margin-top: 2px; }\r\n\r\n.pr-wrap {\r\n  display: grid;\r\n  grid-template-columns: 1.55fr 1fr;\r\n  gap: 14px;\r\n  padding: 14px 18px 40px;\r\n  align-items: start;\r\n}\r\n\r\n@media (max-width: 1080px) {\r\n  .pr-wrap { grid-template-columns: 1fr; }\r\n  .pr-kpis { grid-template-columns: repeat(3, 1fr); }\r\n}\r\n\r\n.pr-col { display: flex; flex-direction: column; gap: 14px; }\r\n\r\n.pr-panel {\r\n  background: var(--surface);\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-lg);\r\n  overflow: hidden;\r\n}\r\n\r\n.pr-panel-head {\r\n  padding: 13px 15px;\r\n  border-bottom: 1px solid var(--line);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n}\r\n\r\n.pr-panel-title {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n}\r\n\r\n.pr-panel-title .pr-step {\r\n  width: 19px;\r\n  height: 19px;\r\n  border-radius: 50%;\r\n  background: var(--ink);\r\n  color: #fff;\r\n  font-size: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.pr-panel-sub { font-size: 11px; color: var(--ink-3); margin-top: 1px; }\r\n.pr-panel-body { padding: 14px 15px; }\r\n\r\n.pr-seg {\r\n  display: inline-flex;\r\n  background: var(--bg);\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-sm);\r\n  padding: 2px;\r\n}\r\n\r\n.pr-seg button {\r\n  border: none;\r\n  background: transparent;\r\n  padding: 6px 12px;\r\n  font-size: 12px;\r\n  font-family: inherit;\r\n  color: var(--ink-2);\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.pr-seg button.active {\r\n  background: var(--surface);\r\n  color: var(--ink);\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\r\n  font-weight: 500;\r\n}\r\n\r\n.pr-filters {\r\n  display: flex;\r\n  gap: 7px;\r\n  margin-bottom: 12px;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n}\r\n\r\n.pr-search { position: relative; flex: 1; min-width: 160px; }\r\n.pr-search i { position: absolute; left: 9px; top: 50%; transform: translateY(-50%); color: var(--ink-3); font-size: 14px; }\r\n.pr-search input {\r\n  width: 100%;\r\n  padding: 8px 10px 8px 28px;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-sm);\r\n  font-size: 12px;\r\n  font-family: inherit;\r\n  outline: none;\r\n  background: var(--surface-2);\r\n}\r\n\r\n.pr-search input:focus { border-color: var(--info-line); background: var(--surface); }\r\n\r\n.pr-selectbox {\r\n  padding: 8px 10px;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-sm);\r\n  font-size: 12px;\r\n  font-family: inherit;\r\n  background: var(--surface-2);\r\n  color: var(--ink-2);\r\n  outline: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.pr-chip-toggle {\r\n  padding: 7px 11px;\r\n  border: 1px solid var(--line);\r\n  border-radius: 16px;\r\n  font-size: 11px;\r\n  color: var(--ink-2);\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  user-select: none;\r\n}\r\n\r\n.pr-chip-toggle.on {\r\n  background: var(--warn-bg);\r\n  border-color: var(--warn-line);\r\n  color: var(--warn);\r\n  font-weight: 500;\r\n}\r\n\r\n.pr-bills { border: 1px solid var(--line); border-radius: var(--r); overflow: hidden; }\r\n\r\n.pr-bills-head,\r\n.pr-bill-row {\r\n  display: grid;\r\n  grid-template-columns: 30px 1.4fr 0.9fr 0.8fr 0.7fr;\r\n  gap: 8px;\r\n  align-items: center;\r\n  padding: 8px 11px;\r\n}\r\n\r\n.pr-bills-head {\r\n  background: var(--surface-2);\r\n  font-size: 9px;\r\n  letter-spacing: 0.4px;\r\n  color: var(--ink-3);\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  border-bottom: 1px solid var(--line);\r\n}\r\n\r\n.pr-bill-row { border-bottom: 1px solid var(--line); cursor: pointer; }\r\n.pr-bill-row:last-child { border-bottom: none; }\r\n.pr-bill-row:hover { background: var(--surface-2); }\r\n.pr-bill-row.sel { background: var(--info-bg); }\r\n\r\n.pr-bill-cust { font-size: 12px; font-weight: 500; }\r\n.pr-bill-meta { font-size: 10px; color: var(--ink-3); }\r\n.pr-bill-amt { font-size: 12px; font-weight: 500; text-align: right; }\r\n.pr-bill-due { font-size: 11px; }\r\n\r\n.pr-age {\r\n  font-size: 9px;\r\n  padding: 2px 6px;\r\n  border-radius: 7px;\r\n  display: inline-block;\r\n  font-weight: 500;\r\n}\r\n\r\n.pr-age.cur { background: var(--ok-bg); color: var(--ok); }\r\n.pr-age.w30 { background: var(--warn-bg); color: var(--warn); }\r\n.pr-age.w60 { background: #F6E0C8; color: #7A3E05; }\r\n.pr-age.w90 { background: var(--bad-bg); color: var(--bad); }\r\n\r\n.pr-ck {\r\n  width: 17px;\r\n  height: 17px;\r\n  border: 1.5px solid var(--line-2);\r\n  border-radius: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: transparent;\r\n}\r\n\r\n.pr-bill-row.sel .pr-ck,\r\n.pr-ck.on {\r\n  background: var(--info);\r\n  border-color: var(--info);\r\n  color: #fff;\r\n}\r\n\r\n.pr-ck i { font-size: 12px; }\r\n\r\n.pr-bills-foot {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  padding: 9px 11px;\r\n  background: var(--surface-2);\r\n  border-top: 1px solid var(--line);\r\n  font-size: 11px;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.pr-pagination {\r\n  margin-top: 12px;\r\n  padding: 4px 2px 0;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.pr-pagination .pagination-container {\r\n  width: auto;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.pr-pagination .help-text {\r\n  display: none;\r\n}\r\n\r\n.pr-pagination .pagination-button {\r\n  font-size: 11px;\r\n  padding: 6px 12px;\r\n  border-radius: 7px;\r\n  border: 1px solid var(--line);\r\n  background: var(--surface);\r\n  color: var(--ink-2);\r\n}\r\n\r\n.pr-pagination .pagination-button:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.pr-pagination .pagination-button:not(:disabled):hover {\r\n  background: var(--surface-2);\r\n  border-color: var(--line-2);\r\n}\r\n\r\n.pr-link { color: var(--info); cursor: pointer; font-weight: 500; background: none; border: none; font-family: inherit; font-size: inherit; padding: 0; }\r\n\r\n.pr-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }\r\n\r\n.pr-fld { display: flex; flex-direction: column; gap: 4px; }\r\n.pr-fld label { font-size: 11px; color: var(--ink-2); }\r\n\r\n.pr-fld input {\r\n  padding: 8px 10px;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-sm);\r\n  font-size: 12px;\r\n  font-family: inherit;\r\n  outline: none;\r\n  background: var(--surface-2);\r\n  color: var(--ink);\r\n}\r\n\r\n.pr-fld input:focus { border-color: var(--info-line); background: var(--surface); }\r\n\r\n.pr-basket-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  padding: 8px 10px;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-sm);\r\n  margin-bottom: 6px;\r\n  background: var(--surface-2);\r\n}\r\n\r\n.pr-basket-meta { flex: 1; min-width: 0; }\r\n.pr-basket-name { font-size: 12px; font-weight: 500; }\r\n.pr-basket-sub { font-size: 10px; color: var(--ink-3); }\r\n.pr-basket-amt { font-size: 12px; font-weight: 500; }\r\n.pr-x-btn { color: var(--ink-3); cursor: pointer; font-size: 15px; background: none; border: none; padding: 0; }\r\n.pr-x-btn:hover { color: var(--bad); }\r\n\r\n.pr-pod-add {\r\n  width: 34px;\r\n  height: 34px;\r\n  border: 1.5px dashed var(--line-2);\r\n  border-radius: var(--r-sm);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--ink-3);\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.pr-pod-add:hover { border-color: var(--info); color: var(--info); }\r\n.pr-pod-add i { font-size: 16px; }\r\n\r\n.pr-pod-thumb {\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: var(--r-sm);\r\n  overflow: hidden;\r\n  position: relative;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n  border: 1px solid var(--ok-line);\r\n}\r\n\r\n.pr-pod-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }\r\n\r\n.pr-pod-tick {\r\n  position: absolute;\r\n  right: -1px;\r\n  bottom: -1px;\r\n  width: 14px;\r\n  height: 14px;\r\n  background: var(--ok);\r\n  color: #fff;\r\n  border-radius: 4px 0 0 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.pr-pod-tick i { font-size: 9px; }\r\n\r\n.pr-cfg-label {\r\n  font-size: 10px;\r\n  letter-spacing: 0.4px;\r\n  color: var(--ink-3);\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  margin: 0 0 9px;\r\n}\r\n\r\n.pr-cfg-block { padding: 14px 15px; border-bottom: 1px solid var(--line); }\r\n.pr-cfg-block:last-child { border-bottom: none; }\r\n\r\n.pr-channels { display: flex; gap: 8px; }\r\n\r\n.pr-channel {\r\n  flex: 1;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r);\r\n  padding: 11px 8px;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.pr-channel i { font-size: 19px; color: var(--ink-3); }\r\n.pr-channel-name { font-size: 11px; margin-top: 4px; color: var(--ink-2); }\r\n.pr-channel.on { border-color: var(--info-line); background: var(--info-bg); }\r\n.pr-channel.on i { color: var(--info); }\r\n.pr-channel.on .pr-channel-name { color: var(--info); font-weight: 500; }\r\n.pr-channel .pr-tick { font-size: 11px; color: var(--info); height: 13px; }\r\n\r\n.pr-rule { display: flex; align-items: center; gap: 9px; padding: 7px 0; cursor: pointer; }\r\n\r\n.pr-rule .pr-box {\r\n  width: 17px;\r\n  height: 17px;\r\n  border: 1.5px solid var(--line-2);\r\n  border-radius: 4px;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: transparent;\r\n}\r\n\r\n.pr-rule.on .pr-box { background: var(--info); border-color: var(--info); color: #fff; }\r\n.pr-rule .pr-box i { font-size: 12px; }\r\n.pr-rule-txt { font-size: 12px; }\r\n.pr-rule-sub { font-size: 10px; color: var(--ink-3); }\r\n\r\n.pr-rule.recommend .pr-rule-txt::after {\r\n  content: \"AI pick\";\r\n  font-size: 8px;\r\n  background: var(--purple-bg);\r\n  color: var(--purple);\r\n  padding: 1px 5px;\r\n  border-radius: 6px;\r\n  margin-left: 6px;\r\n  vertical-align: middle;\r\n  font-weight: 500;\r\n}\r\n\r\n.pr-var-row { display: flex; flex-wrap: wrap; gap: 5px; margin: 8px 0; }\r\n\r\n.pr-var {\r\n  font-size: 10px;\r\n  background: var(--bg);\r\n  border: 1px solid var(--line);\r\n  padding: 3px 7px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  color: var(--ink-2);\r\n  font-family: var(--mono);\r\n}\r\n\r\n.pr-var:hover { border-color: var(--info-line); color: var(--info); }\r\n\r\n.pr-preview {\r\n  background: var(--surface-2);\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-sm);\r\n  padding: 11px;\r\n  font-size: 12px;\r\n  color: var(--ink-2);\r\n  line-height: 1.6;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.pr-preview .pr-v {\r\n  background: var(--info-bg);\r\n  color: var(--info);\r\n  border-radius: 3px;\r\n  padding: 0 3px;\r\n}\r\n\r\n.pr-preview.pr-purple {\r\n  border-color: var(--purple-line);\r\n  background: var(--purple-bg);\r\n}\r\n\r\n.pr-preview .pr-v-purple {\r\n  background: #DAD7F7;\r\n  color: var(--purple);\r\n  border-radius: 3px;\r\n  padding: 0 3px;\r\n}\r\n\r\n.pr-switch-row { display: flex; align-items: center; justify-content: space-between; padding: 7px 0; }\r\n.pr-switch-row .pr-lbl { font-size: 12px; }\r\n.pr-switch-row .pr-sub { font-size: 10px; color: var(--ink-3); }\r\n\r\n.pr-sw {\r\n  width: 36px;\r\n  height: 21px;\r\n  border-radius: 11px;\r\n  background: var(--line-2);\r\n  position: relative;\r\n  cursor: pointer;\r\n  transition: background 0.15s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.pr-sw::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 17px;\r\n  height: 17px;\r\n  border-radius: 50%;\r\n  background: #fff;\r\n  top: 2px;\r\n  left: 2px;\r\n  transition: left 0.15s;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.pr-sw.on { background: var(--ok); }\r\n.pr-sw.on::after { left: 17px; }\r\n.pr-sw.locked { opacity: 0.55; cursor: not-allowed; }\r\n\r\n.pr-soon-badge {\r\n    display: inline-block;\r\n    margin-left: 6px;\r\n    padding: 1px 6px;\r\n    font-size: 9px;\r\n    font-weight: 600;\r\n    letter-spacing: 0.03em;\r\n    text-transform: uppercase;\r\n    color: var(--info);\r\n    background: var(--info-bg);\r\n    border: 1px solid var(--info-line);\r\n    border-radius: 4px;\r\n    vertical-align: middle;\r\n}\r\n\r\n.pr-due-input {\r\n    font-size: 11px;\r\n    padding: 3px 6px;\r\n    border: 1px solid var(--line);\r\n    border-radius: 5px;\r\n    background: var(--surface);\r\n    color: var(--ink);\r\n    max-width: 130px;\r\n}\r\n\r\n.pr-due-input.inline {\r\n    margin: 0 4px;\r\n    vertical-align: middle;\r\n}\r\n\r\n.pr-esc-step {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  padding: 6px 0;\r\n  font-size: 11px;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.pr-esc-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }\r\n\r\n.pr-attach-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; }\r\n\r\n.pr-attach {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 11px;\r\n  color: var(--ink-2);\r\n  padding: 7px 9px;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-sm);\r\n  cursor: pointer;\r\n  background: none;\r\n  font-family: inherit;\r\n}\r\n\r\n.pr-attach.on { border-color: var(--ok-line); background: var(--ok-bg); color: var(--ok); }\r\n.pr-attach i { font-size: 14px; }\r\n\r\n.pr-tmpl-textarea {\r\n  width: 100%;\r\n  min-height: 96px;\r\n  padding: 10px;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-sm);\r\n  font-family: inherit;\r\n  font-size: 12px;\r\n  resize: vertical;\r\n  outline: none;\r\n  background: var(--surface-2);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.pr-tmpl-textarea:focus { border-color: var(--info-line); background: var(--surface); }\r\n\r\n.pr-launch { position: sticky; bottom: 0; }\r\n\r\n.pr-summary-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 11px;\r\n  padding: 4px 0;\r\n  color: var(--ink-2);\r\n}\r\n\r\n.pr-summary-row b { color: var(--ink); font-weight: 500; }\r\n\r\n.pr-btn {\r\n  width: 100%;\r\n  padding: 12px;\r\n  border: none;\r\n  border-radius: var(--r);\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  font-family: inherit;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n}\r\n\r\n.pr-btn.primary { background: var(--ink); color: #fff; }\r\n.pr-btn.primary:hover:not(:disabled) { opacity: 0.92; }\r\n.pr-btn:disabled { opacity: 0.4; cursor: not-allowed; }\r\n.pr-btn.ghost {\r\n  background: transparent;\r\n  border: 1px solid var(--line);\r\n  color: var(--ink-2);\r\n  width: auto;\r\n  padding: 10px 16px;\r\n}\r\n\r\n.pr-empty { text-align: center; padding: 26px 14px; color: var(--ink-3); }\r\n.pr-empty i { font-size: 30px; color: var(--line-2); display: block; margin-bottom: 8px; }\r\n\r\n.pr-toast-wrap {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 80;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  align-items: center;\r\n}\r\n\r\n.pr-toast {\r\n  background: var(--ink);\r\n  color: #fff;\r\n  padding: 10px 16px;\r\n  border-radius: var(--r-sm);\r\n  font-size: 12px;\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  animation: pr-rise 0.2s;\r\n}\r\n\r\n.pr-toast.bad { background: var(--bad); }\r\n\r\n@keyframes pr-rise {\r\n  from { transform: translateY(8px); opacity: 0; }\r\n}\r\n\r\n.pr-modal-bg {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(26, 26, 26, 0.45);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 90;\r\n  padding: 20px;\r\n}\r\n\r\n.pr-modal {\r\n  background: var(--surface);\r\n  border-radius: var(--r-lg);\r\n  max-width: 440px;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.pr-modal-top { padding: 18px 20px; text-align: center; }\r\n\r\n.pr-modal-icon {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  background: var(--ok-bg);\r\n  color: var(--ok);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 12px;\r\n  font-size: 26px;\r\n}\r\n\r\n.pr-modal-title { font-size: 16px; font-weight: 500; margin-bottom: 5px; }\r\n.pr-modal-msg { font-size: 12px; color: var(--ink-2); line-height: 1.55; }\r\n\r\n.pr-modal-list {\r\n  background: var(--surface-2);\r\n  border-radius: var(--r-sm);\r\n  padding: 11px 13px;\r\n  margin: 13px 0 0;\r\n  text-align: left;\r\n}\r\n\r\n.pr-modal-foot { padding: 0 20px 18px; display: flex; gap: 8px; }\r\n\r\n.pr-pay-list {\r\n  margin-top: 14px;\r\n  max-height: 280px;\r\n  overflow: auto;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-sm);\r\n  background: var(--surface-2);\r\n}\r\n\r\n.pr-pay-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  padding: 10px 12px;\r\n  border-bottom: 1px solid var(--line);\r\n}\r\n\r\n.pr-pay-row:last-child { border-bottom: none; }\r\n\r\n.pr-pay-main { min-width: 0; flex: 1; }\r\n\r\n.pr-pay-customer {\r\n  font-weight: 500;\r\n  font-size: 12px;\r\n}\r\n\r\n.pr-pay-meta {\r\n  font-size: 11px;\r\n  color: var(--ink-3);\r\n  margin-top: 2px;\r\n}\r\n\r\n.pr-pay-id {\r\n  font-family: var(--mono);\r\n  font-size: 10px;\r\n  color: var(--ok);\r\n  background: var(--ok-bg);\r\n  border: 1px solid var(--ok-line);\r\n  border-radius: 6px;\r\n  padding: 4px 7px;\r\n  white-space: nowrap;\r\n  max-width: 46%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.pr-pod-hint {\r\n  font-size: 10px;\r\n  color: var(--ink-3);\r\n  margin-top: 6px;\r\n  display: flex;\r\n  gap: 5px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.pr-pod-hint i { font-size: 12px; margin-top: 1px; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
